import {
  Button,
  ConfigProvider,
  Form,
  Select,
  message,
  Steps,
  theme,
  Radio,
} from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import m3_logo from "../assets/images/M3_Logo.svg";
import logo from "../assets/images/signup_bg.svg";
import { UserOutlined } from "@ant-design/icons";
import { Progress_Circle } from "../utils/icons";
function GetToKnow() {
  const { token } = theme.useToken();
  const [current, setCurrent] = useState(0);
  const next = () => {
    setCurrent(current + 1);
  };
  // const prev = () => {
  //   setCurrent(current - 1);
  // };
  const steps = [
    {
      // title: "First",
      // content: "First-content",
      icon: <Progress_Circle />,
    },
    {
      // title: "Second",
      // content: "Second-content",
      icon: <Progress_Circle />,
    },
    {
      // title: "third",
      // content: "third-content",
      icon: <Progress_Circle />,
    },
    {
      // title: "forth",
      // content: "forth-content",
      icon: <Progress_Circle />,
    },
  ];

  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
    icon: item.icon,
  }));
  const contentStyle = {
    // lineHeight: "260px",
    // textAlign: "center",
    // color: token.colorTextTertiary,
    // backgroundColor: token.colorFillAlter,
    // borderRadius: token.borderRadiusLG,
    // border: `1px dashed ${token.colorBorder}`,
    // marginTop: 16,
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Input: {
            colorBgContainer: "transparent",
            colorIcon: "white",
            colorIconHover: "white",
            colorTextPlaceholder: "#DADADA",
          },
          Steps: {
            colorPrimary: "#FF6B38",
            // colorText: "#262626",
            colorTextLabel: "white",
            fontSize: "20px",
          },
          Radio: {
            colorPrimary: "#FF6B38",
            colorText: "white",
            fontSize: "20px",
          },
          Button: {
            colorPrimaryHover:
              "linear-gradient(270deg, #E3302E 0%, #FF6B38 44.79%, #FFA380 100%)",
          },
        },
      }}
    >
      <div className="bg-getToKnowBg bg-darkJungleGreen h-screen flex justify-center items-center text-white bg-right-bottom bg-no-repeat bg-[length:800px]">
        <div className=" m3_logo_register absolute top-10 left-16">
          <img src={m3_logo} />
        </div>
        <div className="bg-black px-72 py-12 rounded-2xl text-center space-y-10">
          <Steps className="w-[500px]" current={current}>
            <Steps.Step
              // title="First"
              icon={current === 0 ? <Progress_Circle /> : 1}
            />
            <Steps.Step
              // title="Second"
              icon={current === 1 ? <Progress_Circle /> : 2}
            />
            <Steps.Step
              // title="Third"
              icon={current === 2 ? <Progress_Circle /> : 3}
            />
            <Steps.Step
              // title="Fourth"
              icon={current === 3 ? <Progress_Circle /> : 4}
            />
          </Steps>
          <h1 className="font-bold bg-signupTextBg inline-block text-transparent bg-clip-text text-2xl">
            Let's Get to know you more !
          </h1>
          <p>Why do you want to join M3 ?</p>
          <div className="text-white" style={contentStyle}>
            {steps[current].content}
            <Radio.Group
              defaultValue={1}
              className="flex w-[300px] m-auto flex-col space-y-5 text-white items-center [&>label]:px-4 [&>label]:py-1 [&>label]:w-full [&>label]:rounded-3xl [&>label]:bg-[#1F1F1F]"
              // onChange={onChange}
              // value={value}
            >
              <Radio value={1}>Answer A</Radio>
              <Radio value={2}>Answer B</Radio>
              <Radio value={3}>Answer C</Radio>
            </Radio.Group>
          </div>
          <div
            style={{
              marginTop: 24,
            }}
          >
            {current < steps.length - 1 && (
              <Button
                className="w-[300px] m-auto bg-signupSubmitBtn rounded-3xl text-lg"
                type="primary"
                onClick={() => next()}
              >
                Next
              </Button>
            )}
            {current === steps.length - 1 && (
              <Button
                color="primary"
                className="w-[300px] m-auto bg-signupSubmitBtn rounded-3xl text-lg"
                type="primary"
                // onClick={() => message.success("Processing complete!")}
              >
                Done
              </Button>
            )}
            {/* {current > 0 && (
              <Button
                style={{
                  margin: "0 8px",
                }}
                onClick={() => prev()}
              >
                Previous
              </Button>
            )} */}
          </div>
        </div>
      </div>
    </ConfigProvider>
  );
}

export default GetToKnow;
